import { render, staticRenderFns } from "./main-header-language.vue?vue&type=template&id=4bc10492&scoped=true"
import script from "./main-header-language.vue?vue&type=script&lang=js"
export * from "./main-header-language.vue?vue&type=script&lang=js"
import style0 from "./main-header-language.vue?vue&type=style&index=0&id=4bc10492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc10492",
  null
  
)

export default component.exports